var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 387.8",
    style: {
      enableBackground: "new 0 0 500 387.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#FAFAFA;}\n\t.st2{fill:#F5F5F5;}\n\t.st3{fill:#E0E0E0;}\n\t.st4{fill:#F0F0F0;}\n\t.st5{fill:#E6E6E6;}\n\t.st6{display:none;}\n\t.st7{display:inline;}\n\t.st8{fill:#407BFF;}\n\t.st9{opacity:0.9;fill:#FFFFFF;}\n\t.st10{fill:#262C38;}\n\t.st11{opacity:0.6;fill:#FFFFFF;}\n\t.st12{opacity:0.8;fill:#FFFFFF;}\n\t.st13{opacity:0.2;}\n\t.st14{fill:#FFFFFF;}\n\t.st15{fill:none;stroke:#262C38;stroke-miterlimit:10;}\n\t.st16{opacity:0.1;fill:#FFFFFF;}\n\t.st17{opacity:0.2;fill:#FFFFFF;}\n\t.st18{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st19{opacity:0.6;}\n\t.st20{fill:none;stroke:#262C38;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:#6371E0;}\n\t.st22{opacity:0.7;fill:#FFFFFF;}\n\t.st23{fill:#EBBF76;}\n\t.st24{fill:#D59845;}\n\t.st25{fill:#DE6853;}\n\t.st26{opacity:0.3;}\n\t.st27{opacity:0.7;}\n\t.st28{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st29{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st30{opacity:0.1;}\n\t.st31{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st32{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st33{opacity:0.7;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 334.6,
    className: "st0",
    width: 500,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.8,
    y: 350.7,
    className: "st0",
    width: 33.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.5,
    y: 353.4,
    className: "st0",
    width: 8.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 341.4,
    className: "st0",
    width: 19.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 343.1,
    className: "st0",
    width: 43.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.6,
    y: 343.1,
    className: "st0",
    width: 6.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 347.3,
    className: "st0",
    width: 93.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,290H43.9c-3.1,0-5.7-2.6-5.7-5.7V12.9c0-3.1,2.6-5.7,5.7-5.7H237c3.1,0,5.7,2.6,5.7,5.7v271.4 C242.7,287.4,240.2,290,237,290z M43.9,7.4c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.5-2.4,5.5-5.5V12.9 c0-3-2.4-5.5-5.5-5.5H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,290H260.2c-3.1,0-5.7-2.6-5.7-5.7V12.9c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.6,5.7,5.7v271.4 C459,287.4,456.5,290,453.3,290z M260.2,7.4c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5h193.1c3,0,5.5-2.4,5.5-5.5V12.9 c0-3-2.4-5.5-5.5-5.5H260.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 55.6,
    className: "st1",
    width: 71.3,
    height: 241.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "157.2,55.6 153,55.6 128.2,297.3 132.3,297.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 56.5,
    className: "st3",
    width: 70.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 295.2,
    className: "st0",
    width: 70.4,
    height: 4.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    y: 299.5,
    className: "st0",
    width: 66.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.8,56.5 165.4,56.5 165.4,299.5 169.4,299.5 169.4,53.5 94.8,53.5 94.8,299.5 98.8,299.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 175.8,
    y: 55.6,
    className: "st1",
    width: 71.3,
    height: 241.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "227.3,55.6 204.6,55.6 179.8,297.3 202.5,297.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.4,
    y: 56.5,
    className: "st3",
    width: 72.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.4,
    y: 295.2,
    className: "st0",
    width: 72.4,
    height: 4.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178.1,
    y: 299.5,
    className: "st0",
    width: 66.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "178.1,56.5 244.7,56.5 244.7,299.5 248.6,299.5 248.6,53.5 174.1,53.5 174.1,299.5 178.1,299.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.1,
    y: 55.6,
    className: "st1",
    width: 69.3,
    height: 241.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "294.4,55.6 290.2,55.6 265.3,297.3 269.5,297.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 254.7,
    y: 56.5,
    className: "st3",
    width: 70.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.7,
    y: 295.2,
    className: "st0",
    width: 70.4,
    height: 4.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.4,
    y: 299.5,
    className: "st0",
    width: 66.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "257.4,56.5 323.9,56.5 323.9,299.5 327.9,299.5 327.9,53.5 253.4,53.5 253.4,299.5 257.4,299.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 334.4,
    y: 55.6,
    className: "st1",
    width: 71.3,
    height: 241.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "398.7,55.6 376,55.6 351.1,297.3 373.8,297.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 56.5,
    className: "st3",
    width: 70.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 295.2,
    className: "st0",
    width: 70.4,
    height: 4.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "336.7,56.5 403.2,56.5 403.2,299.5 407.2,299.5 407.2,53.5 332.7,53.5 332.7,299.5 336.7,299.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.7,
    y: 299.5,
    className: "st0",
    width: 66.6,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 241.7,
    className: "st0",
    width: 30.9,
    height: 53.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "139.8,234.2 139.8,247.6 137.4,247.6 123.2,247.6 120.8,247.6 120.8,234.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 491.2764)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 491.2764)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 491.2764)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 491.2764)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 505.6679)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 505.6679)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 505.6679)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 505.6679)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 520.0594)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 520.0594)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 520.0594)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 237.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 478.8373)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 237.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 478.8373)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 520.0594)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 534.4508)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 534.4508)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 534.4508)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 534.4508)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 548.8424)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 548.8424)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 548.8424)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 548.8424)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 563.2338)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 563.2338)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 563.2338)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 563.2338)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 283.5905 577.6253)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 268.2487 577.6253)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 252.9069 577.6253)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 237.5652 577.6253)",
    className: "st4",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.2,
    y: 241.7,
    className: "st0",
    width: 30.9,
    height: 53.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "314.2,234.2 314.2,247.6 311.8,247.6 297.6,247.6 295.2,247.6 295.2,234.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 491.2764)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 491.2764)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 491.2764)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 243.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 491.2764)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 505.6679)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 505.6679)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 505.6679)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 250.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 505.6679)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 520.0594)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 520.0594)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 520.0594)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 237.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 478.8373)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 237.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 478.8373)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 520.0594)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 534.4508)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 534.4508)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 534.4508)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 265.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 534.4508)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 548.8424)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 548.8424)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 548.8424)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 272.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 548.8424)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 563.2338)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 563.2338)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 563.2338)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 279.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 563.2338)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 632.3737 577.6253)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.5,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0319 577.6253)",
    className: "st1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 601.6901 577.6253)",
    className: "st4",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.2,
    y: 286.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 586.3484 577.6253)",
    className: "st4",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.6,
    y: 261.2,
    className: "st4",
    width: 27.7,
    height: 34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "344,264.9 350.4,264.9 352.2,264.9 354,264.9 354,268.5 352.2,268.5 350.4,268.5 344,268.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "344,271.8 350.4,271.8 352.2,271.8 354,271.8 354,275.4 352.2,275.4 350.4,275.4 344,275.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "344,278.7 350.4,278.7 352.2,278.7 354,278.7 354,282.2 352.2,282.2 350.4,282.2 344,282.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "344,285.5 350.4,285.5 353.2,285.5 354,285.5 354,289.1 353.2,289.1 350.4,289.1 344,289.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.9,264.9 363.3,264.9 365.1,264.9 366.9,264.9 366.9,268.5 365.1,268.5 363.3,268.5  356.9,268.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.9,271.8 363.3,271.8 365.8,271.8 366.9,271.8 366.9,275.4 365.8,275.4 363.3,275.4  356.9,275.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "356.9,278.7 363.3,278.7 365.1,278.7 366.9,278.7 366.9,282.2 365.1,282.2 363.3,282.2  356.9,282.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.9,285.5 363.3,285.5 365.1,285.5 366.9,285.5 366.9,289.1 365.1,289.1 363.3,289.1  356.9,289.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.9,
    y: 274,
    className: "st4",
    width: 25.2,
    height: 21.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 467.8008 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 455.314 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 442.8271 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 430.3402 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 467.8008 568.2803)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 455.314 568.2803)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 442.8271 568.2803)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 430.3402 568.2803)",
    className: "st5",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 467.8008 579.9937)",
    className: "st5",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 455.314 579.9937)",
    className: "st5",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 442.8271 579.9937)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 430.3402 579.9937)",
    className: "st5",
    width: 3.2,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.4,
    y: 274,
    className: "st4",
    width: 25.2,
    height: 21.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.7,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 566.6878 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 554.201 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 541.7141 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 276.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 529.2272 556.5669)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.7,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 566.6878 568.2803)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 554.201 568.2803)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 541.7141 568.2803)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 282.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 529.2272 568.2803)",
    className: "st5",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.7,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 566.6878 579.9937)",
    className: "st5",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 554.201 579.9937)",
    className: "st5",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 541.7141 579.9937)",
    className: "st1",
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 288.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 529.2272 579.9937)",
    className: "st5",
    width: 3.2,
    height: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.4,
    y: 258.4,
    className: "st4",
    width: 25.2,
    height: 36.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.5,
    y: 260,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 260,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.5,
    y: 271.7,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 271.7,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.5,
    y: 283.5,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 283.5,
    className: "st1",
    width: 9.5,
    height: 9.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 373.5,
    y: 258.4,
    className: "st4",
    width: 25.2,
    height: 36.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.6,
    y: 260,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 260,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.6,
    y: 271.7,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 271.7,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.6,
    y: 283.5,
    className: "st1",
    width: 9.5,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 283.5,
    className: "st1",
    width: 9.5,
    height: 9.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.4,308.3c0,0-5.1-11,0.7-21.9c5.8-10.9,7.5-13.5,3.8-15.7c-3.7-2.2-5.4,8.7-5.4,8.7s-3.1-7.5-0.5-15.4 c2.6-7.9,4.2-20.7,0.7-22.1c-3.5-1.4-0.7,16-3.7,21.9c0,0-2.6-6.6-3-12.9c-0.4-6.3,0.2-16.4-2.5-19c-2.8-2.6-4.5-0.8-1.8,13.2 s2.7,25.3,2.7,25.3s-6-18.3-10-18.9c-4-0.5-4,5.4-0.6,10.5c3.5,5.1,10.1,14.4,11.2,19.1c0,0-6.6-13.8-12.5-9.6 c-5.9,4.2,5.2,12.6,10.1,15.6c4.9,3,8.4,21.9,8.4,21.9L83.4,308.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,312.8c0,0,4.9-11.1-1-21.9c-5.9-10.8-7.6-13.3-4-15.6c3.7-2.3,5.5,8.6,5.5,8.6s3-7.6,0.4-15.4 c-2.7-7.8-4.4-20.6-0.9-22.1c3.5-1.4,0.9,16,4,21.9c0,0,2.5-6.6,2.8-13c0.3-6.3-0.4-16.4,2.3-19.1c2.7-2.6,4.5-0.9,2,13.1 c-2.6,14-2.4,25.4-2.4,25.4s5.8-18.4,9.8-19c4-0.6,4.1,5.3,0.7,10.5c-3.4,5.2-9.9,14.5-11,19.3c0,0,6.4-13.9,12.4-9.7 c6,4.1-5,12.6-9.9,15.7c-4.9,3.1-8.1,22-8.1,22L79.4,312.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "102.1,304.9 61.4,304.9 64.7,334 98.8,334  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.5,302.8c0.1-1,3.5-24.3-3.2-32.3c-1.5-1.8-3.4-2.7-5.6-2.8c-13.7-0.3-15.5,10.7-15.5,10.8l1.6,0.2 c0.1-0.4,1.7-9.7,13.9-9.4c1.8,0,3.2,0.8,4.4,2.2c6.3,7.5,2.9,30.8,2.9,31L407.5,302.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.3,301.8l1.6-0.1c0-0.2-0.5-21.5,9.9-25.9c10.3-4.3,14.9,4.5,15.1,4.9l1.5-0.7 c-0.1-0.1-5.5-10.6-17.2-5.7C407.7,279.2,408.3,300.8,408.3,301.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.3,303.4c0-0.3,0.1-34,6.7-43.8c6.3-9.4,16.4-5,16.9-4.8l0.7-1.5c-0.1-0.1-11.8-5.2-18.9,5.4 c-6.8,10.2-6.9,43.3-6.9,44.7L408.3,303.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.7,268.5c0,0,6,2.2,4.2,7.4c-1.8,5.2-20.6,13.7-20.6,13.7s-7.9-7.2-0.6-19 C386.8,258.9,396.5,264.8,396.7,268.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M415.2,257.9c0,0-4.2-0.5-3.9-3c0.3-2.6,16.5-9.2,26,1.5c0,0-6.1,10.5-14.9,10.6 C413.6,267.1,415.2,257.9,415.2,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M419.6,275.1c0,0-2.9-2.4,0.2-3.5c3.2-1.2,18.6-0.8,18.8,14.5c0,0-18,3-20.3-2.8 C416.1,277.4,419.6,275.1,419.6,275.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "393.5,334 421.4,334 424.4,303.4 390.4,303.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.9,
    y: 300,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 814.8846 606.8546)",
    className: "st3",
    width: 37,
    height: 6.8
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88,68.7C115.9,9.3,215,17.7,253.3,59.5c38.3,41.8,50.7,68.6,85.2,53c34.5-15.6,78.5-11.4,81,38.2 s-37.9,108.3-102.1,125.6c-64.2,17.4-64.2,78.8-149.1,66.4c-46.3-6.8-47.4-56.9-40.8-98.3S55.6,137.7,88,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88,68.7C115.9,9.3,215,17.7,253.3,59.5c38.3,41.8,50.7,68.6,85.2,53c34.5-15.6,78.5-11.4,81,38.2 s-37.9,108.3-102.1,125.6c-64.2,17.4-64.2,78.8-149.1,66.4c-46.3-6.8-47.4-56.9-40.8-98.3S55.6,137.7,88,68.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    className: "st2",
    cx: 250,
    cy: 368.4,
    rx: 193.9,
    ry: 11.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "398.6,360.3 406,361.1 405.1,339.1 396.2,340.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "359.6,360.5 367.1,359.8 369,340.4 360,340.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "398.6,360.3 406,361.1 405.1,339.1 396.2,340.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "359.6,360.5 367.1,359.8 369,340.4 360,340.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M396.5,197.3c0,0-0.8,5-1.2,5s-5-4.4-5-4.4l3.1-4.3L396.5,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M396.5,197.3c0,0-0.8,5-1.2,5s-5-4.4-5-4.4l3.1-4.3L396.5,197.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M388.5,137.9c4.5,1,17.8,30.6,19,35.3s-10.3,26.3-10.3,26.3l-5.5-6.1l6.4-20.2l-10.5-18.6L388.5,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M388.5,137.9c4.5,1,17.8,30.6,19,35.3s-10.3,26.3-10.3,26.3l-5.5-6.1l6.4-20.2l-10.5-18.6L388.5,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M407.3,359.2H398c-0.3,0-0.6,0.2-0.6,0.5l-1.6,6.7c-0.2,0.7,0.4,1.4,1.1,1.3c3-0.1,5.1-0.2,8.9-0.2 c2.3,0,9.2,0.2,12.4,0.2c3.1,0,3.6-3.1,2.3-3.4c-5.8-1.3-10.2-3-12-4.7C408.2,359.4,407.7,359.2,407.3,359.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M367.2,198.1c0,0,2.8,14.3,6.2,31.6c2,9.9,4.2,20.8,6.2,30.5c0.7,3.5,1.5,6.8,2.1,9.9 c5.2,23.6,14.7,86.1,14.7,86.1l11.7-1.9c0,0-2.3-67.9-6-92c-3.4-21.9-10.2-72.9-10.2-72.9L367.2,198.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373.4,229.6c2,9.9,4.2,20.8,6.2,30.5c4.1-21.2-3-39.1-3-39.1C375.4,223.7,374.4,226.6,373.4,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M368.2,359.2H359c-0.3,0-0.6,0.2-0.6,0.5l-1.6,6.7c-0.2,0.7,0.4,1.4,1.1,1.3c3-0.1,5.1-0.2,8.9-0.2 c2.3,0,9.2,0.2,12.4,0.2c3.1,0,3.6-3.1,2.3-3.4c-5.8-1.3-10.2-3-12-4.7C369.1,359.4,368.7,359.2,368.2,359.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M376.9,190.3c0,0-0.3,51.4-0.1,73.6c0.3,24.3-7.1,92-7.1,92l-11.9-1c0,0-0.5-62-2.3-86.1 c-2.1-26.9-3.6-73.4-3.6-73.4L376.9,190.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M352,197.3c0-4-0.5-10.4-0.7-15.9c-0.1-5.1-0.4-10.7-1-16.6c-0.8-8-2.1-16.6-4.2-25c0,0,4.8-1.3,10.2-2.1 c1.1-0.2,2.2-0.3,3.2-0.4c5.2-0.5,12.6-1.1,17.2-1c0.7,0,1.4,0.1,2.1,0.1c5.2,0.4,9.6,1.3,9.6,1.3s8.8,19.8,4.5,57.9L352,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M352,197.3c0-4-0.5-10.4-0.7-15.9c-0.1-5.1-0.4-10.7-1-16.6c-0.8-8-2.1-16.6-4.2-25c0,0,4.8-1.3,10.2-2.1 c1.1-0.2,2.2-0.3,3.2-0.4c5.2-0.5,12.6-1.1,17.2-1c0.7,0,1.4,0.1,2.1,0.1c5.2,0.4,9.6,1.3,9.6,1.3s8.8,19.8,4.5,57.9L352,197.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M348.7,152.4c0.7,4.2,1.2,8.4,1.6,12.5c0.1,0.7,0.1,1.4,0.2,2.1c2.2-6.7,1.5-13.2,1.5-13.2 C350.7,153,349.6,152.5,348.7,152.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M360.3,118c1.3,5.5,2.9,15.5-0.8,19.4c3,2.8,7.3,5,13.5,4.5c4.8-0.4,4.8-3.7,3.7-5.5 c-6.2-1.1-6.3-5.7-5.4-10.1L360.3,118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M360.3,118c1.3,5.5,2.9,15.5-0.8,19.4c3,2.8,7.3,5,13.5,4.5c4.8-0.4,4.8-3.7,3.7-5.5 c-6.2-1.1-6.3-5.7-5.4-10.1L360.3,118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M364.8,121.5l6.5,5c-0.2,1-0.4,2.1-0.4,3.1c-2.4-0.2-5.7-2.6-6.1-5.1C364.6,123.2,364.6,122,364.8,121.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M357.6,110.7c1.8,7.4,2.5,11.8,7,14.9c6.7,4.7,15.3-0.6,15.7-8.4c0.4-7-2.7-17.9-10.6-19.5 C362.1,96.2,355.8,103.3,357.6,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M357.6,110.7c1.8,7.4,2.5,11.8,7,14.9c6.7,4.7,15.3-0.6,15.7-8.4c0.4-7-2.7-17.9-10.6-19.5 C362.1,96.2,355.8,103.3,357.6,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M369.3,110.6c0.1,0.6,0.5,1,0.9,1c0.4-0.1,0.6-0.6,0.5-1.2c-0.1-0.6-0.5-1-0.9-1 C369.5,109.4,369.2,110,369.3,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M376.2,109.2c0.1,0.6,0.5,1,0.9,1c0.4-0.1,0.6-0.6,0.5-1.2c-0.1-0.6-0.5-1-0.9-1 C376.3,108.1,376.1,108.6,376.2,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M374.1,110c0,0,2,3.1,3.9,4.4c-0.9,1.2-2.8,1.1-2.8,1.1L374.1,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M372.3,118.4c0.3,0,0.5,0,0.8-0.1c0.1,0,0.2-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.1c-2.7,0.5-4.3-1.1-4.3-1.1 c-0.1-0.1-0.2-0.1-0.3,0c-0.1,0.1-0.1,0.2,0,0.3C368.6,117.2,370,118.6,372.3,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M366.8,108.8c0.1,0,0.2-0.1,0.3-0.2c0.7-1.5,2.1-1.6,2.1-1.6c0.2,0,0.3-0.2,0.3-0.4c0-0.2-0.2-0.3-0.4-0.3 c-0.1,0-1.7,0.2-2.6,2c-0.1,0.2,0,0.4,0.2,0.5C366.7,108.8,366.7,108.8,366.8,108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M378.7,106.3c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.2-0.3,0.1-0.5c-1.2-1.6-2.9-1.5-2.9-1.5 c-0.2,0-0.4,0.2-0.3,0.4c0,0.2,0.2,0.4,0.4,0.3c0.1,0,1.4-0.1,2.3,1.2C378.5,106.2,378.6,106.3,378.7,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M368.2,102.4c0,0-2.3-1.1-3,0.7c-0.6,1.8,0.3,6,0.3,6l-0.6-0.7c0,0-0.8,9.9-5.1,8.3 c-4.3-1.6-11.8-10-3.8-16.7c0,0,0.5-2.5,6.2-4.8c5.7-2.3,13.6-0.1,15.6,3.6c2,3.7,0.7,6.2,0.7,6.2c-0.6-1.4-1.6-2.1-1.6-2.1 c0.1,1.3-1.1,2.1-1.1,2.1c-0.3-1.6-0.9-2.2-0.9-2.2c0.1,0.9-0.6,2.1-0.6,2.1c-1.2-3.9-4.1-4.2-5-4 C368.1,101.2,368.2,102.4,368.2,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M355.9,117.5c1,1.8,2.7,3,4.3,3.5c2.4,0.7,3.7-1.5,3-3.8c-0.6-2.1-2.6-5-5-4.6 C355.8,112.8,354.8,115.4,355.9,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M355.9,117.5c1,1.8,2.7,3,4.3,3.5c2.4,0.7,3.7-1.5,3-3.8c-0.6-2.1-2.6-5-5-4.6 C355.8,112.8,354.8,115.4,355.9,117.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M376.4,141l-0.9,3.6c0,0,4.1,22.3,4.9,34.1l-1.8,3l-2.6-2.6c0,0-0.6-30.3-1.7-34.4l-3.1-2.8l2.4-2 L376.4,141z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "373.6,139.6 360.1,133.2 356.3,137.9 368,146.5 374.1,140.7 381,145.2 379.9,136.7 372,133.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "373.6,139.6 360.1,133.2 356.3,137.9 368,146.5 374.1,140.7 381,145.2 379.9,136.7 372,133.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "386.4,199.3 364.4,200.5 364.2,197.8 386.2,196.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.1,197.9 363.4,200.5 352.2,201.1 352.1,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.5,196.9 392.9,196.7 393.2,198.9 387.7,199.2  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M379.4,197.5l0.2,2.1c0,0.3-0.2,0.6-0.5,0.6l-4.4,0.2c-0.3,0-0.5-0.2-0.6-0.5l-0.2-2.1 c0-0.3,0.2-0.6,0.5-0.6l4.3-0.2C379.1,197,379.4,197.2,379.4,197.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M397.8,202.2l-1.9-5c-1-2.2-4.4-0.2-4.4-0.2c-0.3,0.2-0.5,0.6-0.4,0.9l2.6,9.6c0.3,1,1.6,1.3,2.3,0.5l0.9-1 C398,205.7,398.4,203.9,397.8,202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M397.8,202.2l-1.9-5c-1-2.2-4.4-0.2-4.4-0.2c-0.3,0.2-0.5,0.6-0.4,0.9l2.6,9.6c0.3,1,1.6,1.3,2.3,0.5l0.9-1 C398,205.7,398.4,203.9,397.8,202.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M334.9,236.1c0,1.7,3.4,3.2,7.6,3.3c4.2,0.1,7.7-1.2,7.8-2.9c0-1.7-3.4-3.2-7.6-3.3 C338.4,233.1,334.9,234.4,334.9,236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M323.2,236.6l-0.6,27.2c0,0.9,0.7,1.6,1.6,1.7l39.7,0.9c0.9,0,1.6-0.7,1.7-1.6l0.6-27.2 c0-0.9-0.7-1.6-1.6-1.7l-39.7-0.9C323.9,235,323.2,235.7,323.2,236.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M323.2,236.6l-0.6,27.2c0,0.9,0.7,1.6,1.6,1.7l39.7,0.9c0.9,0,1.6-0.7,1.7-1.6l0.6-27.2 c0-0.9-0.7-1.6-1.6-1.7l-39.7-0.9C323.9,235,323.2,235.7,323.2,236.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M362.2,237.5l-0.6,27.2c0,0.9,0.7,1.6,1.6,1.7l0.7,0c0.9,0,1.6-0.7,1.7-1.6l0.6-27.2c0-0.9-0.7-1.6-1.6-1.7 l-0.7,0C363,235.9,362.2,236.6,362.2,237.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M363.4,235.9c-0.8,0-1.5,0.8-1.6,1.6l-0.3,12.6c0,0.7-0.6,1.3-1.3,1.3l-36.4-0.8c-0.7,0-1.3-0.6-1.3-1.3 l0.3-12.6c0-0.9,0.8-1.6,1.6-1.6l39.7,0.9L363.4,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M363.4,235.9c-0.8,0-1.5,0.8-1.6,1.6l-0.3,12.6c0,0.7-0.6,1.3-1.3,1.3l-36.4-0.8c-0.7,0-1.3-0.6-1.3-1.3 l0.3-12.6c0-0.9,0.8-1.6,1.6-1.6l39.7,0.9L363.4,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M339.8,257l3,0.1c0.3,0,0.5-0.2,0.5-0.5l0.2-7.3l-3.9-0.1l-0.2,7.3C339.4,256.7,339.6,257,339.8,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M339.7,254.9l3.4,0.1c0.4,0,0.7-0.3,0.8-0.7l0-1.6c0-0.4-0.3-0.7-0.7-0.8l-3.4-0.1c-0.4,0-0.7,0.3-0.8,0.7 l0,1.6C338.9,254.6,339.2,254.9,339.7,254.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M339,224.3l-0.8,7.7l8.1-2.8c0,0,0.3-6.9-3.2-6.9L339,224.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "339.8,235.4 346.6,235 346.2,229.1 338.2,231.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M339,224.3l-0.8,7.7l8.1-2.8c0,0,0.3-6.9-3.2-6.9L339,224.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "339.8,235.4 346.6,235 346.2,229.1 338.2,231.9  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M346.1,139.9c-2.9,3.5-10.6,32.2-11.6,40.8c-1.1,8.6,4,44.2,4,44.2l7.7-1.2c0,0-2.4-37.2-1.3-39.6 c1.1-2.4,7.7-28.8,7.7-28.8s0.7-5.1-0.3-8.6C351.1,143.1,346.1,139.9,346.1,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M346.1,139.9c-2.9,3.5-10.6,32.2-11.6,40.8c-1.1,8.6,4,44.2,4,44.2l7.7-1.2c0,0-2.4-37.2-1.3-39.6 c1.1-2.4,7.7-28.8,7.7-28.8s0.7-5.1-0.3-8.6C351.1,143.1,346.1,139.9,346.1,139.9z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lamps"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 77.7,
    y1: 46.3,
    x2: 422.3,
    y2: 46.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 228.8,
    y: 33.7,
    width: 25,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.7,
    y: 26.2,
    className: "st10",
    width: 34.4,
    height: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "265.8,57.5 234.8,57.5 158.7,367.8 341.9,367.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.3,62.9 245.3,62.9 240.5,57 231.2,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "265.8,57.5 234.8,57.5 158.7,367.8 341.9,367.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "263.7,57.5 236.9,57.5 170.8,367.8 329.8,367.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "270.5,29.2 270.5,62.9 241.1,62.9 239.4,59.6 231.9,59.6 230.8,62.9 230.3,62.9 230.3,29.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.8,
    y: 29.2,
    className: "st16",
    width: 28.7,
    height: 33.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M238.5,35.6c0,2.4-1.4,4.4-3.1,4.4c-0.1,0-0.3,0-0.4-0.1c-1.5-0.3-2.7-2.1-2.7-4.3c0-2.2,1.2-4,2.7-4.3 c0.1,0,0.3-0.1,0.4-0.1C237.1,31.2,238.5,33.2,238.5,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M237.6,35.6c0,2.2-1.2,4-2.6,4.3c-1.5-0.3-2.7-2.1-2.7-4.3c0-2.2,1.2-4,2.7-4.3 C236.5,31.6,237.6,33.4,237.6,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M235.7,35.6c0,1.1-0.5,1.9-1.1,1.9c-0.6,0-1.1-0.9-1.1-1.9c0-1.1,0.5-1.9,1.1-1.9 C235.2,33.7,235.7,34.5,235.7,35.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 246.8,
    y: 33.7,
    className: "st10",
    width: 25,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.9,
    y: 34.1,
    className: "st16",
    width: 22.9,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.3,
    y: 36.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 305.6353 -214.9857)",
    className: "st21",
    width: 18,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M259.7,51.4c-0.3,0-0.6-0.2-0.8-0.5l-4.7-6.6c-0.4-0.6-0.3-1.4,0.1-1.8c0.5-0.5,1.2-0.4,1.6,0.2l3.9,5.4 l6.4-8.9c0.4-0.6,1.1-0.6,1.6-0.2c0.5,0.5,0.5,1.3,0.1,1.8l-7.2,10.1C260.3,51.2,260,51.4,259.7,51.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.9,
    y: 33.7,
    width: 25,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.8,
    y: 26.2,
    className: "st10",
    width: 34.4,
    height: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.4,62.9 365.4,62.9 360.6,57 351.2,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "390.6,29.2 390.6,62.9 361.2,62.9 359.5,59.6 352,59.6 350.9,62.9 350.4,62.9 350.4,29.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.9,
    y: 29.2,
    className: "st16",
    width: 28.7,
    height: 33.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M358.6,35.6c0,2.4-1.4,4.4-3.1,4.4c-0.1,0-0.3,0-0.4-0.1c-1.5-0.3-2.7-2.1-2.7-4.3c0-2.2,1.2-4,2.7-4.3 c0.1,0,0.3-0.1,0.4-0.1C357.2,31.2,358.6,33.2,358.6,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M357.7,35.6c0,2.2-1.2,4-2.6,4.3c-1.5-0.3-2.7-2.1-2.7-4.3c0-2.2,1.2-4,2.7-4.3 C356.5,31.6,357.7,33.4,357.7,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M355.8,35.6c0,1.1-0.5,1.9-1.1,1.9c-0.6,0-1.1-0.9-1.1-1.9c0-1.1,0.5-1.9,1.1-1.9 C355.3,33.7,355.8,34.5,355.8,35.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 366.9,
    y: 33.7,
    className: "st10",
    width: 25,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.9,
    y: 34.1,
    className: "st16",
    width: 22.9,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.4,
    y: 36.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 425.7072 -335.0576)",
    className: "st21",
    width: 18,
    height: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M382,45.3l4.8-5.2c0.5-0.5,0.5-1.3,0-1.8c-0.4-0.5-1.2-0.5-1.6,0l-4.8,5.2l-4.8-5.2c-0.5-0.5-1.2-0.5-1.6,0 c-0.5,0.5-0.5,1.3,0,1.8l4.8,5.2l-4.8,5.2c-0.5,0.5-0.5,1.3,0,1.8c0.2,0.2,0.5,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.4l4.8-5.2 l4.8,5.2c0.2,0.2,0.5,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.4c0.5-0.5,0.5-1.3,0-1.8L382,45.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 33.7,
    width: 25,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.6,
    y: 26.2,
    className: "st10",
    width: 34.4,
    height: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.2,62.9 125.2,62.9 120.4,57 111.1,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "150.5,29.2 150.5,62.9 121.1,62.9 119.3,59.6 111.9,59.6 110.7,62.9 110.2,62.9 110.2,29.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 29.2,
    className: "st16",
    width: 28.7,
    height: 33.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M118.4,35.6c0,2.4-1.4,4.4-3.1,4.4c-0.1,0-0.3,0-0.4-0.1c-1.5-0.3-2.7-2.1-2.7-4.3c0-2.2,1.2-4,2.7-4.3 c0.1,0,0.3-0.1,0.4-0.1C117,31.2,118.4,33.2,118.4,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M117.5,35.6c0,2.2-1.2,4-2.6,4.3c-1.5-0.3-2.7-2.1-2.7-4.3c0-2.2,1.2-4,2.7-4.3 C116.4,31.6,117.5,33.4,117.5,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M115.6,35.6c0,1.1-0.5,1.9-1.1,1.9c-0.6,0-1.1-0.9-1.1-1.9c0-1.1,0.5-1.9,1.1-1.9 C115.1,33.7,115.6,34.5,115.6,35.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 33.7,
    className: "st10",
    width: 25,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.8,
    y: 34.1,
    className: "st16",
    width: 22.9,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.2,
    y: 36.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 185.5632 -94.9137)",
    className: "st21",
    width: 18,
    height: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M141.9,45.3l4.8-5.2c0.5-0.5,0.5-1.3,0-1.8c-0.4-0.5-1.2-0.5-1.6,0l-4.8,5.2l-4.8-5.2 c-0.4-0.5-1.2-0.5-1.6,0c-0.4,0.5-0.4,1.3,0,1.8l4.8,5.2l-4.8,5.2c-0.4,0.5-0.4,1.3,0,1.8c0.2,0.2,0.5,0.4,0.8,0.4 c0.3,0,0.6-0.1,0.8-0.4l4.8-5.2l4.8,5.2c0.2,0.2,0.5,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.4c0.5-0.5,0.5-1.3,0-1.8L141.9,45.3z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M230.4,355.5l0.8,1.1l1.6-0.7l1,4.8l6.6,9.1c0,0,2.5,0.4,0.5-4.8c-0.1-0.2-0.2-0.5-0.2-0.8 c-0.6-3.1,0.7-9,0.7-9l-3.6-5c0,0-0.4,0-1,0.1C235.2,350.6,232.2,351.3,230.4,355.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M230.4,355.5l0.8,1.1l1.6-0.7l1,4.8l6.6,9.1c0,0,2.5,0.4,0.5-4.8c-0.1-0.2-0.2-0.5-0.2-0.8 c-0.6-3.1,0.7-9,0.7-9l-3.6-5c0,0-0.4,0-1,0.1C235.2,350.6,232.2,351.3,230.4,355.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M236.7,350.3C236.7,350.3,236.6,350.4,236.7,350.3c1.2,0.1,0.1,5.5,0.6,8.5c0.4,2.7,1.6,5.2,3.3,5.5 c-0.6-3.1,1.5-10.2,1.5-10.2l-2.9-4C239.2,350.1,237.3,350.2,236.7,350.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M236.7,350.3C236.7,350.3,236.6,350.4,236.7,350.3c1.2,0.1,0.1,5.5,0.6,8.5c0.4,2.7,1.6,5.2,3.3,5.5 c-0.6-3.1,1.5-10.2,1.5-10.2l-2.9-4C239.2,350.1,237.3,350.2,236.7,350.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M240.4,369.5l1.3,0l0.4-1.7l4.4,2h11.2c0,0,1.8-1.8-3.6-3.2c-0.2-0.1-0.5-0.2-0.8-0.3 c-2.9-1.3-6.9-5.9-6.9-5.9h-6.2c0,0-0.2,0.3-0.5,0.9C239.2,362.7,238.1,365.6,240.4,369.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M239.9,361.4C239.9,361.4,239.9,361.4,239.9,361.4c0.8-0.9,4.5,3.1,7.2,4.5c2.4,1.2,5.1,1.7,6.4,0.5 c-2.9-1.3-7.3-7.2-7.3-7.2h-5C241.2,359.1,240.2,360.8,239.9,361.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M289.2,159.9l-2.7-7.1l8.4,0.7c0,0,2,6.5-1.4,7.4L289.2,159.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "287.9,145.5 294.9,148.5 294.9,153.6 286.5,152.9  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M294.5,160.1c0,0-0.4,31.5-7.4,31.5c-3.9,0-8.3-2.5-12-5.4c-4.9-3.8-8.7-8.1-8.7-8.1l0-0.1l-2.4-14.6 c6.9-0.2,18.9,15.6,18.9,15.6l5.8-20L294.5,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M275.1,186.2c-4.9-3.8-8.7-8.1-8.7-8.1l0-0.1l2.2-5C268.6,173,274.7,178,275.1,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M235.7,128.4c0,0,2.2-3.8,8.5-4.4c6.3-0.6,14.6,2.7,15.9,12.3c1.3,9.6,4,14.8,4,14.8s-20.2,5.3-25.9,3.4 C232.4,152.5,223.7,131.1,235.7,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M274.4,296.6c-3,5.5-6,11.5-9,17.5c-3.8,7.9-7.5,15.8-10.6,22.9c-3.3,7.5-5.9,14-7.6,18.5 c-1.6,0.2-6.3-2.6-7.7-5.2c0,0,3.4-21.8,11-42.8c3.1-8.4,6.8-16.6,11.3-23.2c-18.4-52.3-13.9-72-13.9-72l21.3-1 c0,0,3.2,19.5,5.8,39.5c0,0,0,0,0,0c1.3,10.5,2.5,21.1,2.9,29.1v0.1C278.4,285.8,277.2,291.5,274.4,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M256.8,268.7c-2.7-8.9-4.6-16.6-6-23.2c1.4-5.2,3.3-9.6,5.9-12.3C256.8,233.2,260.5,247.6,256.8,268.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M254.9,337c-3.3,7.5-5.9,14-7.6,18.5c-1.6,0.2-6.3-2.6-7.7-5.2c0,0,3.4-21.8,11-42.8 C252.2,316.1,254,327.1,254.9,337z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.3,209c0,0-6.2,48-9.8,71.1c-3.7,24.3-4.2,63.2-3.3,79.1c-1.4,0.8-6.3,1.7-9,0.9 c0,0-12.7-49.1-4.2-77.6c-7.7-56.2,3.4-69.9,3.4-69.9L261.3,209z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M259.2,178.7c-9.1-8.6-20.6-14.4-20.6-14.4c0.7-0.1,1.4-0.1,2.1-0.2c5.2-0.4,9.5-0.7,14.2-0.5 c1.2,0.1,2.4,0.2,3.6,0.3v0C261.4,170.7,259.2,178.7,259.2,178.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M238.6,209c-0.6-7.3-3.3-20.6-7.7-34.7c-1.5-4.6,1-9.7,1-9.7s6.1-0.2,6.7-0.2c0.7-0.1,1.4-0.1,2.1-0.2 c5.2-0.4,9.5-0.7,14.2-0.5c1.2,0.1,2.4,0.2,3.6,0.3c0.4,0,4.7,0.1,5.1,0.1c0,0,5.9,6.8,6.3,12.3c0.2,3.1,0.7,5.4,0.5,12.8 c0,5-0.4,11.6-0.7,18.6L238.6,209z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M238.6,209c-0.6-7.3-3.3-20.6-7.7-34.7c-1.5-4.6,1-9.7,1-9.7s6.1-0.2,6.7-0.2c0.7-0.1,1.4-0.1,2.1-0.2 c5.2-0.4,9.5-0.7,14.2-0.5c1.2,0.1,2.4,0.2,3.6,0.3c0.4,0,4.7,0.1,5.1,0.1c0,0,5.9,6.8,6.3,12.3c0.2,3.1,0.7,5.4,0.5,12.8 c0,5-0.4,11.6-0.7,18.6L238.6,209z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M238.6,209l31-2.1c0,0,0.9,9.3,0.7,9.2c-0.2-0.1-33.2,1.2-33.2,1.2L238.6,209z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.9,209.5 269.6,207.8 269.6,210.7 238.6,212.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M255.6,211.1l-0.1-1.7c0-0.3,0.2-0.6,0.5-0.6l3.4-0.3c0.3,0,0.6,0.2,0.6,0.6v1.8c0,0.3-0.2,0.6-0.6,0.6 l-3.2,0.2C255.9,211.7,255.6,211.4,255.6,211.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M241.1,230.3l-10.7-1.9l6.2-23.1c0,0-1.6-5.7-3.4-12.3c-0.9-3.2-1.7-6.6-2.5-9.6c-1.1-4.4-1.9-8-2-9.1 c-0.2-3.7,3.1-9.6,3.1-9.6l7.7-1.3c0,0,7.1,7.8,7.5,22.7C247.6,201,241.1,230.3,241.1,230.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M257.3,163.4c0,0,6.7,11.7,8.3,20.4c1.6,8.7,5.8,45.5,5.8,45.5l2.3-1.2l-3.2-22c0,0,1.2-25.5,0.3-30.7 c-0.9-5.2-6.8-12-6.8-12H257.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M254,162.8l0.5-0.4c0,0,6.6,0.8,12.6,8.3l-2.3,2.3l4,3.2l-1.9,15.5c0,0-6.1-20.6-8.7-25.5 C258.1,166.1,255.9,163.7,254,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M254,162.8l0.5-0.4c0,0,6.6,0.8,12.6,8.3l-2.3,2.3l4,3.2l-1.9,15.5c0,0-6.1-20.6-8.7-25.5 C258.1,166.1,255.9,163.7,254,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M241.1,163.4c0,0,7.5,8.3,5.8,30l-7.3-15.6l2.7-4.3l-6.2-5.8c0,0,3.3-6.2,5.6-5.6L241.1,163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M241.1,163.4c0,0,7.5,8.3,5.8,30l-7.3-15.6l2.7-4.3l-6.2-5.8c0,0,3.3-6.2,5.6-5.6L241.1,163.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M256.7,165.7L255,176l-13.5-11.8c2.9-3.2,1.1-11.5-0.3-16l3.8,2.9l5.7,4.3c-0.1,1,0,2.3,0.3,3.5 c0.4,1.8,1.2,3.5,2.1,3.9L256.7,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M250.9,158.8c-2.3-0.5-5.3-2.9-5.7-5.2c-0.2-1-0.3-1.9-0.2-2.6l5.7,4.3 C250.5,156.2,250.7,157.5,250.9,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M242.1,161.5c0,0,5.8,4.5,12.6,13.9c0,0,0.6-9.4-1.7-12.8l0.5-0.6c0,0,5,1.9,9,7.1l-4.5-1.4l-3.1,8.3 l-9.2-7.6l-6.2,1.1C239.4,169.5,239.7,163.4,242.1,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M242.1,161.5c0,0,5.8,4.5,12.6,13.9c0,0,0.6-9.4-1.7-12.8l0.5-0.6c0,0,5,1.9,9,7.1l-4.5-1.4l-3.1,8.3 l-9.2-7.6l-6.2,1.1C239.4,169.5,239.7,163.4,242.1,161.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M236.9,139.1c1.6,7.3,2.2,10.5,6.5,13.9c6.5,5.1,15.1,2,15.7-5.6c0.5-6.8-2.3-17.7-9.9-19.8 C241.6,125.4,235.3,131.7,236.9,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246.4,140c0.1,0.6,0.5,1.1,0.9,1c0.4,0,0.6-0.6,0.5-1.2c-0.1-0.6-0.5-1.1-0.9-1 C246.5,138.8,246.3,139.4,246.4,140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M254.1,138.9c0.1,0.6,0.5,1.1,0.9,1c0.4,0,0.6-0.6,0.5-1.2c-0.1-0.6-0.5-1.1-0.9-1 C254.2,137.8,254,138.3,254.1,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M254.5,137.8l1.4-0.6C255.9,137.2,255.3,138.4,254.5,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M252,140.5c0,0,1.5,2.6,2.9,3.7c-0.7,0.9-2.1,0.7-2.1,0.7L252,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M244.5,136.2c0.1,0,0.2,0,0.3-0.1c1-1.2,2.3-1,2.4-1c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.1-0.4-0.3-0.4 c-0.1,0-1.7-0.3-3,1.2c-0.1,0.1-0.1,0.4,0.1,0.5C244.4,136.2,244.4,136.2,244.5,136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M256.6,134.5c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.2-0.4,0-0.5c-1.3-1.6-3-1.5-3.1-1.5c-0.2,0-0.3,0.2-0.3,0.4 c0,0.2,0.2,0.4,0.4,0.3c0.1,0,1.4-0.1,2.4,1.2C256.4,134.4,256.5,134.5,256.6,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246.7,138.8l1.4-0.6C248.1,138.3,247.6,139.5,246.7,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M240.7,143.3c0,0,3.6-5.3,0.9-13c0,0,8.2-4,14.3,2.1c0,0-5.7-10.1-17.8-5.3c-12,4.8-3,16.4-1.5,17.3 C238.1,145.4,240.7,143.3,240.7,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M235.4,145.4c1.1,1.4,2.6,2.2,4,2.3c2,0.2,2.6-1.8,1.7-3.7c-0.8-1.7-2.9-3.9-4.8-3.2 C234.5,141.5,234.2,143.8,235.4,145.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M253.2,146.6c-0.5,1-1,2.9-1,2.9c-0.2,0-0.4,0-0.5-0.1c-2.4-0.2-3.5-1.2-3.9-2.1c-0.2-0.5-0.3-1-0.2-1.5 c0-0.5,0.2-0.8,0.2-0.8c1.2,0.9,3.5,1.3,4.7,1.5C252.9,146.6,253.2,146.6,253.2,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M252.4,146.5l-0.3,0.8c-2.3-0.2-3.9-0.7-4.5-1.5c0-0.5,0.2-0.8,0.2-0.8C248.9,146,251.2,146.4,252.4,146.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M251.7,149.5c-2.4-0.2-3.5-1.2-3.9-2.1c0.8,0.1,1.8,0.3,2.7,0.8C251.1,148.5,251.5,149,251.7,149.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M234.7,191.2c-0.3,0.8-0.8,1.4-1.4,1.8c-0.9-3.2-1.7-6.6-2.5-9.6c2-2.4,3.7-4.4,3.7-4.4 S236.7,186.1,234.7,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M231.9,164.6c-4.2,0.5-17.2,32.8-16.5,37.9c0.8,5.1,28.7,2.8,28.7,2.8v-7.8l-16.3-3.3l5.6-11.1 c0,0,1.7-5.2,1.2-9.9C234.2,168.4,231.9,164.6,231.9,164.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M249.1,217.1l-21.4-2.6c-0.8-0.1-1.4-0.8-1.3-1.6l3.8-27.6c0.1-0.8,0.9-1.4,1.7-1.3l21.4,2.6 c0.8,0.1,1.4,0.8,1.3,1.6l-3.8,27.6C250.7,216.7,249.9,217.2,249.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M249.1,217.1l-21.4-2.6c-0.8-0.1-1.4-0.8-1.3-1.6l3.8-27.6c0.1-0.8,0.9-1.4,1.7-1.3l21.4,2.6 c0.8,0.1,1.4,0.8,1.3,1.6l-3.8,27.6C250.7,216.7,249.9,217.2,249.1,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M248.2,217l-20.5-2.5c-0.8-0.1-1.4-0.8-1.3-1.6l3.8-27.6c0.1-0.8,0.9-1.4,1.7-1.3l20.5,2.5 c0.8,0.1,1.4,0.8,1.3,1.6l-3.8,27.6C249.8,216.6,249,217.1,248.2,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M240,198.2c-1.3-0.2-2.5,0.7-2.7,2c-0.2,1.2,0.7,2.4,2,2.5c1.3,0.2,2.5-0.7,2.7-2 C240.7,200.6,239.8,199.5,240,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M247.3,188.1l-11.3-1.4c-0.6-0.1-1-0.5-1.1-1l-0.3-1.4l15,1.8l-0.8,1.3 C248.4,187.9,247.8,188.2,247.3,188.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M250.1,196.6l-6.4,1.8l-1.3,4.2c0.6,3.4,7.2,2,7.2,2l1.4,0.9c1.1,0.7,2.5,0,2.8-1.2l0.7-4 c0.1-0.7-0.1-1.3-0.7-1.8l-2-1.6C251.3,196.5,250.7,196.4,250.1,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M218.9,189.2c-2.2,6.1-3.7,11.5-3.5,13.3c0.8,5.1,28.7,2.8,28.7,2.8v-7.8l-16.3-3.3L218.9,189.2z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M279.9,106h-12.3c-2.3,0-4.2,1.9-4.2,4.2v11.9c0,2.3,1.9,4.2,4.2,4.2h2.9l-0.7,4.5l3.5-4.5h6.5 c2.3,0,4.2-1.9,4.2-4.2v-11.9C284.1,107.9,282.2,106,279.9,106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M269.5,113.8c1.1-1.8,3.2-1.1,4.2,0.2c1.1-1.4,3.1-2.1,4.2-0.3c1.9,3-1.9,5.8-3.6,6.9 c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1-0.1-0.3-0.2-0.5-0.3C271.5,119.5,267.7,116.8,269.5,113.8z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M138.8,159.6c0.3,0.3,0.6,0.6,0.9,0.9c0.2,0.3,0.4,0.5,0.6,0.8c0.3,0.5,0.6,1,0.8,1.4 c0.5,0.9,0.8,1.7,1.1,2.5c0.5,1.5,0.9,3,1.3,4.4c0.7,2.8,1.1,5.6,1.5,8.3c0.4,2.7,0.6,5.5,0.9,8.2c0.1,1.4,0.2,2.7,0.3,4.1l0.2,4 c0.2,2.4,0.4,5,0.7,7.6c0.3,2.6,0.7,5.2,1,7.8c0.7,5.2,1.5,10.5,2.2,15.8l0,0c0.2,1.4-0.8,2.8-2.3,3c-1.3,0.2-2.4-0.6-2.8-1.7 c-1.8-5.1-3.4-10.2-4.8-15.5c-0.7-2.6-1.4-5.2-2-7.9c-0.6-2.7-1.1-5.4-1.5-8.2l-0.5-4l-0.5-3.9c-0.4-2.6-0.8-5.2-1.2-7.7 c-0.5-2.5-0.9-5-1.5-7.4c-0.3-1.2-0.6-2.3-0.9-3.3c-0.2-0.5-0.4-0.9-0.5-1.2c-0.1-0.2-0.1-0.2-0.2-0.3c0,0,0,0,0,0 c0.1,0.1,0.1,0.1,0.2,0.2c-2.2-2-2.3-5.3-0.4-7.5S136.6,157.6,138.8,159.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M138.8,159.6c0.3,0.3,0.6,0.6,0.9,0.9c0.2,0.3,0.4,0.5,0.6,0.8c0.3,0.5,0.6,1,0.8,1.4 c0.5,0.9,0.8,1.7,1.1,2.5c0.5,1.5,0.9,3,1.3,4.4c0.7,2.8,1.1,5.6,1.5,8.3c0.4,2.7,0.6,5.5,0.9,8.2c0.1,1.4,0.2,2.7,0.3,4.1l0.2,4 c0.2,2.4,0.4,5,0.7,7.6c0.3,2.6,0.7,5.2,1,7.8c0.7,5.2,1.5,10.5,2.2,15.8l0,0c0.2,1.4-0.8,2.8-2.3,3c-1.3,0.2-2.4-0.6-2.8-1.7 c-1.8-5.1-3.4-10.2-4.8-15.5c-0.7-2.6-1.4-5.2-2-7.9c-0.6-2.7-1.1-5.4-1.5-8.2l-0.5-4l-0.5-3.9c-0.4-2.6-0.8-5.2-1.2-7.7 c-0.5-2.5-0.9-5-1.5-7.4c-0.3-1.2-0.6-2.3-0.9-3.3c-0.2-0.5-0.4-0.9-0.5-1.2c-0.1-0.2-0.1-0.2-0.2-0.3c0,0,0,0,0,0 c0.1,0.1,0.1,0.1,0.2,0.2c-2.2-2-2.3-5.3-0.4-7.5C133.3,157.8,136.6,157.6,138.8,159.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M151.1,224.9l3.8,6.6l-8.4,0.6c0,0-3-6.1,0.2-7.5L151.1,224.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "154.6,239 147.2,237.1 146.4,232.1 154.8,231.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M104.3,169.3c-3.1,2.5-6.4,5.3-9.3,8c-1.5,1.4-2.9,2.8-4,4.2c-0.6,0.7-1.1,1.4-1.5,2 c-0.4,0.6-0.5,1.1-0.5,0.9c0-0.4-0.1-0.5-0.1-0.3c0,0.2,0.2,0.4,0.3,0.8c0.3,0.6,0.8,1.4,1.4,2.2c1.1,1.5,2.5,3.1,3.9,4.6 c2.8,3.1,5.8,6.1,8.8,9.1l0,0c1,1,1,2.7,0,3.7c-0.9,0.9-2.2,1-3.2,0.4c-3.9-2.2-7.6-4.7-11.1-7.5c-1.8-1.4-3.5-2.9-5.2-4.7 c-0.8-0.9-1.7-1.9-2.5-3.1c-0.4-0.6-0.8-1.3-1.2-2.1c-0.2-0.4-0.4-0.9-0.5-1.5c-0.1-0.3-0.1-0.6-0.2-0.9c0-0.3-0.1-0.8-0.1-1 c0-1.2,0.3-2.2,0.5-3c0.3-0.8,0.6-1.6,0.9-2.2c0.7-1.3,1.4-2.4,2.1-3.4c1.5-2,3.1-3.8,4.7-5.5c3.3-3.3,6.6-6.2,10.4-9 c2.3-1.7,5.7-1.3,7.4,1.1c1.7,2.3,1.3,5.5-0.9,7.3L104.3,169.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104.3,169.3c-3.1,2.5-6.4,5.3-9.3,8c-1.5,1.4-2.9,2.8-4,4.2c-0.6,0.7-1.1,1.4-1.5,2 c-0.4,0.6-0.5,1.1-0.5,0.9c0-0.4-0.1-0.5-0.1-0.3c0,0.2,0.2,0.4,0.3,0.8c0.3,0.6,0.8,1.4,1.4,2.2c1.1,1.5,2.5,3.1,3.9,4.6 c2.8,3.1,5.8,6.1,8.8,9.1l0,0c1,1,1,2.7,0,3.7c-0.9,0.9-2.2,1-3.2,0.4c-3.9-2.2-7.6-4.7-11.1-7.5c-1.8-1.4-3.5-2.9-5.2-4.7 c-0.8-0.9-1.7-1.9-2.5-3.1c-0.4-0.6-0.8-1.3-1.2-2.1c-0.2-0.4-0.4-0.9-0.5-1.5c-0.1-0.3-0.1-0.6-0.2-0.9c0-0.3-0.1-0.8-0.1-1 c0-1.2,0.3-2.2,0.5-3c0.3-0.8,0.6-1.6,0.9-2.2c0.7-1.3,1.4-2.4,2.1-3.4c1.5-2,3.1-3.8,4.7-5.5c3.3-3.3,6.6-6.2,10.4-9 c2.3-1.7,5.7-1.3,7.4,1.1c1.7,2.3,1.3,5.5-0.9,7.3L104.3,169.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M110.9,206.5c0,0,0.5,7.8,4.3,21.6c1.9,6.9,4.7,15.3,8.7,24.9c1.9,4.6,4.1,9.5,6.6,14.6 c1.1,2.3,2.3,4.7,3.6,7.1c1.5,41.5,24.8,83.8,24.8,83.8c1.3,0.7,5.8-0.1,5.8-1.4c-3.5-5.5-10.2-58.7-14.6-84 c-0.3-3.4-0.7-7.1-1.2-10.9c-1.3-10.2-3.2-21.3-5-31c-2.9-15.4-5.7-27.4-5.7-27.4l-7.7,0.7L110.9,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M110.9,206.5c0,0,0.5,7.8,4.3,21.6c1.9,6.9,4.7,15.3,8.7,24.9c1.9,4.6,4.1,9.5,6.6,14.6 c1.1,2.3,2.3,4.7,3.6,7.1c1.5,41.5,24.8,83.8,24.8,83.8c1.3,0.7,5.8-0.1,5.8-1.4c-3.5-5.5-10.2-58.7-14.6-84 c-0.3-3.4-0.7-7.1-1.2-10.9c-1.3-10.2-3.2-21.3-5-31c-2.9-15.4-5.7-27.4-5.7-27.4l-7.7,0.7L110.9,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M101.8,264L101.8,264c0.6,4.5,1.4,9.2,2.4,14.3c-8.3,27.8,8.8,82,8.8,82c2.9,0.6,5.5,0.2,6.8-0.8 c-3.2-16.3-0.9-58.8,1.6-84.2c0.2-2.3,0.5-4.8,0.8-7.5c0.5-4.6,1.1-9.6,1.8-14.8c1.1-8.7,2.3-17.9,3.5-26.1 c1.4-9.8,2.6-18.2,3.2-22.4c0.3-1.8,0.4-2.9,0.4-2.9l-24,2.6c0,0-6.1,6.9-7,28.3C99.6,240.8,100,251.1,101.8,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M101.8,264L101.8,264c0.6,4.5,1.4,9.2,2.4,14.3c-8.3,27.8,8.8,82,8.8,82c2.9,0.6,5.5,0.2,6.8-0.8 c-3.2-16.3-0.9-58.8,1.6-84.2c0.2-2.3,0.5-4.8,0.8-7.5c0.5-4.6,1.1-9.6,1.8-14.8c1.1-8.7,2.3-17.9,3.5-26.1 c1.4-9.8,2.6-18.2,3.2-22.4c0.3-1.8,0.4-2.9,0.4-2.9l-24,2.6c0,0-6.1,6.9-7,28.3C99.6,240.8,100,251.1,101.8,264z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M135.4,155.4c7.7,2.6,8.2,8,12.6,19.5c-5,7.2-12.6,7.3-12.6,7.3S124.4,161.7,135.4,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M148,174.9c-1.3,1.9-2.8,3.3-4.3,4.3c-1.7,1.2-3.4,1.9-4.8,2.4c-2,0.6-3.5,0.6-3.5,0.6s-0.1-0.1-0.2-0.3 c-0.9-1.7-4.7-9.7-4.7-16.8c0-3.9,1.2-7.6,4.9-9.7C143,158,143.6,163.5,148,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M143.7,179.2c-1.7,1.2-3.4,1.9-4.8,2.4c-1.7-3.5-3.2-7.5-3.6-11.2c2.2-0.2,4.4,0.6,5.8,3 C142.3,175.3,143.2,177.3,143.7,179.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M130.7,123.1c0,0,7.1,17.8,0,33.3c-7.1,15.5-27.1,6.2-29.1,2.5c-2-3.7,2.7-11.3,2.7-18.2s-1.7-10.7-0.4-16.4 C105.1,118.6,130.7,123.1,130.7,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M101.8,264L101.8,264c7.6,2.5,14.4,3.6,20.4,3.8c0.5-4.6,1.1-9.6,1.8-14.8c1.9,4.6,4.1,9.5,6.6,14.6 c8.3-0.8,14.4-3.2,18.4-5.3c-1.3-10.2-3.2-21.3-5-31c-2.2-1.3-4.9-2.5-8.2-3.3c-2.5-0.6-5.3-1-8.3-1c-3.9-0.1-8,0.3-12.2,1.1 c-5.3,1-10.5,2.5-15.3,4.5C99.6,240.8,100,251.1,101.8,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M101.6,156c0,0,1.7,6.2,3.1,16.1c0.4,3,0.9,6.4,1.2,10c0.6,6.6,1,14.2,0.8,22.2h31.7c0,0,5-37-3.3-49 C135.1,155.3,118.9,147.7,101.6,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M101.6,156c0,0,1.7,6.2,3.1,16.1c0.4,3,0.9,6.4,1.2,10c0.6,6.6,1,14.2,0.8,22.2h31.7c0,0,5-37-3.3-49 C135.1,155.3,118.9,147.7,101.6,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M104.7,172.1c0.4,3,0.9,6.4,1.2,10c1.5-2.9,3.2-9.8,0.9-17.1L104.7,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118,149.9c-9.9,0-11.2,8.2-11.2,8.2l4.6-2l13.6,9.1l3.4-9.2l4.2,0.8C132.7,156.8,126.6,149.9,118,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M118,149.9c-9.9,0-11.2,8.2-11.2,8.2l4.6-2l13.6,9.1l3.4-9.2l4.2,0.8C132.7,156.8,126.6,149.9,118,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M124.7,164.7l-12.8-11.1c3.1-3.2,1.5-12,0.2-16.7l9.7,7.8c-0.7,3.7-0.5,7.7,4.9,9 C126.7,153.5,124.7,164.6,124.7,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M124.7,164.7l-12.8-11.1c3.1-3.2,1.5-12,0.2-16.7l9.7,7.8c-0.7,3.7-0.5,7.7,4.9,9 C126.7,153.5,124.7,164.6,124.7,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M116,140l5.7,4.6c-0.2,0.9-0.3,1.8-0.3,2.6c-2.1-0.3-5-2.5-5.4-4.7C115.9,141.5,115.9,140.5,116,140z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M108,127.2c1.5,7.7,1.9,11,6.3,14.7c6.6,5.6,15.7,2.6,16.6-5.3c0.8-7.1-1.7-18.5-9.7-21.1 C113.4,113.1,106.5,119.5,108,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M108,127.2c1.5,7.7,1.9,11,6.3,14.7c6.6,5.6,15.7,2.6,16.6-5.3c0.8-7.1-1.7-18.5-9.7-21.1 C113.4,113.1,106.5,119.5,108,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M114.6,121.6c-4.3,5.5,4.5,11.8-4.3,11.5c-8.8-0.4-5.2-12.7,0-15.5C115.6,114.7,114.6,121.6,114.6,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M120.2,128.5c0.1,0.7,0.5,1.2,0.9,1.1c0.4,0,0.7-0.6,0.6-1.2c-0.1-0.7-0.5-1.2-0.9-1.1 C120.4,127.3,120.1,127.8,120.2,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M128.1,128c0.1,0.7,0.5,1.2,0.9,1.1c0.4,0,0.7-0.6,0.6-1.2c-0.1-0.7-0.5-1.2-0.9-1.1 C128.3,126.8,128,127.3,128.1,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M128.5,126.8l1.5-0.6C130,126.2,129.4,127.5,128.5,126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.1,129.2c0,0,1.5,2.7,2.9,4c-0.7,0.9-2.2,0.6-2.2,0.6L126.1,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M123.4,136.5c0.3,0,0.7,0,1.1,0c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-2.8,0.2-4.4-1.7-4.4-1.7 c-0.1-0.1-0.2-0.1-0.3,0c-0.1,0.1-0.1,0.2,0,0.3C119.8,134.8,121.1,136.3,123.4,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M107.2,134.6c0.8,1.6,2.1,2.6,3.3,2.9c1.8,0.5,2.6-1.6,2-3.6c-0.5-1.9-2.1-4.3-3.9-3.9 C106.9,130.4,106.3,132.8,107.2,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118,125c0.1,0,0.2,0,0.3-0.1c1.1-1.2,2.5-1,2.5-1c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.1-0.4-0.3-0.5 c-0.1,0-1.8-0.3-3.2,1.2c-0.1,0.2-0.1,0.4,0,0.5C117.8,124.9,117.9,125,118,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M129.9,124.2c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.2-0.4,0-0.5c-1.5-1.6-3.2-1.5-3.3-1.5c-0.2,0-0.3,0.2-0.3,0.4 c0,0.2,0.2,0.4,0.4,0.3c0.1,0,1.4-0.1,2.6,1.2C129.7,124.2,129.8,124.2,129.9,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M120.6,127.3l1.5-0.6C122.1,126.7,121.5,128,120.6,127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.3,117.7c0,0-2.3,10.4-10,11.5c-7.6,1.2-5.8-10.1,4.3-14.2c10.2-4.1,18.4,4.1,18.9,6.3 c0.5,2.2-1.6,3.6-1.6,3.6S126.3,117.9,118.3,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M107.2,134.6c0.8,1.6,2.1,2.6,3.3,2.9c1.8,0.5,2.6-1.6,2-3.6c-0.5-1.9-2.1-4.3-3.9-3.9 C106.9,130.4,106.3,132.8,107.2,134.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M112.4,367.5l1.3,0l0.4-1.7l4.4,2h11.2c0,0,1.8-1.8-3.6-3.2c-0.2-0.1-0.5-0.2-0.8-0.3 c-2.9-1.3-6.9-5.9-6.9-5.9h-6.2c0,0-0.2,0.3-0.5,0.9C111.2,360.7,110,363.6,112.4,367.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.8,359.4C111.8,359.4,111.8,359.4,111.8,359.4c0.8-0.9,4.5,3.1,7.2,4.5c2.4,1.2,5.1,1.7,6.4,0.5 c-2.9-1.3-7.3-7.2-7.3-7.2h-5C113.1,357.1,112.1,358.8,111.8,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M111.8,359.4C111.8,359.4,111.8,359.4,111.8,359.4c0.8-0.9,4.5,3.1,7.2,4.5c2.4,1.2,5.1,1.7,6.4,0.5 c-2.9-1.3-7.3-7.2-7.3-7.2h-5C113.1,357.1,112.1,358.8,111.8,359.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.2,367.5l1.3,0l0.4-1.7l4.4,2h11.2c0,0,1.8-1.8-3.6-3.2c-0.2-0.1-0.5-0.2-0.8-0.3 c-2.9-1.3-6.9-5.9-6.9-5.9h-6.2c0,0-0.2,0.3-0.5,0.9C158,360.7,156.8,363.6,159.2,367.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M158.7,359.4C158.7,359.4,158.7,359.4,158.7,359.4c0.8-0.9,4.5,3.1,7.2,4.5c2.4,1.2,5.1,1.7,6.4,0.5 c-2.9-1.3-7.3-7.2-7.3-7.2h-5C159.9,357.1,158.9,358.8,158.7,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M158.7,359.4C158.7,359.4,158.7,359.4,158.7,359.4c0.8-0.9,4.5,3.1,7.2,4.5c2.4,1.2,5.1,1.7,6.4,0.5 c-2.9-1.3-7.3-7.2-7.3-7.2h-5C159.9,357.1,158.9,358.8,158.7,359.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M138.7,201.7h-31.9l-0.9,4.1c0,0-11.7,16.2-5.8,56.7c0,0,25.7,3,49.9-2.2c0,0-5.4-41.6-11.1-55.2 L138.7,201.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "116.3,205.3 105.6,205.3 106.2,202.2 116.3,202.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "135.7,202.2 138.9,202.2 139.2,205.3 135.7,205.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 202.2,
    className: "st10",
    width: 17.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "116.3,205.3 105.6,205.3 106.2,202.2 116.3,202.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "135.7,202.2 138.9,202.2 139.2,205.3 135.7,205.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 202.2,
    className: "st32",
    width: 17.4,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M125.1,205.5h4.7c0.3,0,0.6-0.3,0.6-0.6v-2.4c0-0.3-0.3-0.6-0.6-0.6h-4.7c-0.3,0-0.6,0.3-0.6,0.6v2.4 C124.5,205.2,124.8,205.5,125.1,205.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M103.6,155.3c-3.8,0.2-10.7,6.8-16.5,14.2c4.4,5.4,9.9,10.1,9.9,10.1l11-7.8 C107.9,171.8,109.3,159.6,103.6,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M103.6,155.3c-3.8,0.2-10.7,6.8-16.5,14.2c4.4,5.4,9.9,10.1,9.9,10.1l11-7.8 C107.9,171.8,109.3,159.6,103.6,155.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M124.8,168c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6 C125.1,167.3,124.8,167.6,124.8,168z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 126.7,
    cy: 177.1,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 127.4,
    cy: 186.7,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 127.4,
    cy: 196.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M110.5,207.9l-0.4-2.4c-0.2-0.9-0.7-1.7-1.6-2.1l-3.9-1.9c-1.5-0.7-3.4-0.7-4.9,0.1l-0.9,0.5 c0.4,4,3.8,8.1,3.8,8.1l0.8,1.3c0.8,1.1,2.2,1.4,3.3,0.7l2.5-1.6C110.3,210.1,110.7,209,110.5,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M110.5,207.9l-0.4-2.4c-0.2-0.9-0.7-1.7-1.6-2.1l-3.9-1.9c-1.5-0.7-3.4-0.7-4.9,0.1l-0.9,0.5 c0.4,4,3.8,8.1,3.8,8.1l0.8,1.3c0.8,1.1,2.2,1.4,3.3,0.7l2.5-1.6C110.3,210.1,110.7,209,110.5,207.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M151.1,224.9l3.8,6.6l-8.4,0.6c0,0-3-6.1,0.2-7.5L151.1,224.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "154.6,239 147.2,237.1 146.4,232.1 154.8,231.5  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTeacher);
export default __webpack_public_path__ + "static/media/select_teacher.a8aa4280ddd304f05c72572c2ead5599.svg";
export { ForwardRef as ReactComponent };